export default __webpack_public_path__ + "static/media/product-3.ae455dd1.jpeg";